import templateService from 'services/template.service';
import types from '../actionTypes';

export const fetchParkingTemplate = () => (dispatch, getState) => {
    if (getState().templateData.isFetchingParkingTemplate) {
        return Promise.reject();
    }

    dispatch({
        type: types.PARKING_TEMPLATE_FETCH_REQUEST,
    });

    return templateService.getParkingTemplate()
        .then((parkingTemplate) => {
            dispatch({
                type: types.PARKING_TEMPLATE_FETCH_SUCCESS,
                payload: { parkingTemplate },
            });

            return true;
        })
        .catch((error) => {
            dispatch({
                type: types.PARKING_TEMPLATE_FETCH_FAIL,
                payload: { error },
            });

            throw error;
        });
};